import { render, staticRenderFns } from "./PersonDistinctGender.vue?vue&type=template&id=0be1bc93&"
import script from "./PersonDistinctGender.vue?vue&type=script&lang=js&"
export * from "./PersonDistinctGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports